var map = {
	"./additionalInfoIcon.svg": 590,
	"./arrowBottomIconSharpSmall.svg": 591,
	"./arrowLeftIcon.svg": 592,
	"./arrowMediumTop.svg": 593,
	"./arrowRightIcon.svg": 594,
	"./arrowRightIconSharp.svg": 595,
	"./arrowRightSmallIcon.svg": 596,
	"./arrowScalableIcon.svg": 597,
	"./arrowSelect2.svg": 598,
	"./arrowSelectIcon.svg": 599,
	"./benefit1.svg": 600,
	"./benefit2.svg": 601,
	"./benefit3.svg": 602,
	"./cardsIcon.svg": 603,
	"./circleInfoIcon.svg": 604,
	"./copyIcon copy.svg": 605,
	"./copyIcon.svg": 606,
	"./crossIcon.svg": 607,
	"./crossIcon2.svg": 608,
	"./crossIcon3.svg": 609,
	"./crossIconSmall.svg": 610,
	"./crossSmallIcon.svg": 611,
	"./defaultCategoryIcon.svg": 612,
	"./depNumberIcon.svg": 613,
	"./elfCentralIcon.svg": 614,
	"./equalitySign.svg": 615,
	"./errorIcon.svg": 517,
	"./eyeClosedIcon.svg": 616,
	"./eyeOpenIcon.svg": 617,
	"./favoritesIcon.svg": 618,
	"./favoritesLabelIcon.svg": 619,
	"./filterDivider.svg": 620,
	"./filterIcon.svg": 621,
	"./frequencyIcon.svg": 622,
	"./fsAmountIcon.svg": 623,
	"./fullScreenIcon.svg": 624,
	"./gameIcon.svg": 625,
	"./gemIcon.svg": 626,
	"./goldGiftIcon.svg": 627,
	"./hamburgerIcon.svg": 628,
	"./infoIcon.svg": 629,
	"./infoIconSmall.svg": 630,
	"./infoSymbol.svg": 631,
	"./levelBackground.svg": 632,
	"./levelBackgroundNew.svg": 633,
	"./linkIcon.svg": 634,
	"./lockIcon.svg": 635,
	"./lockSharpIcon.svg": 636,
	"./maxBonusAmountIcon.svg": 637,
	"./maxWinFsIcon.svg": 638,
	"./menuIcon.svg": 639,
	"./minDepIcon.svg": 640,
	"./minusIcon.svg": 641,
	"./noTournamentIcon.svg": 642,
	"./playIcon.svg": 643,
	"./plusIcon.svg": 644,
	"./polygon.svg": 645,
	"./preloaderDotsAnimation.svg": 646,
	"./preloaderSpinnerAnimation.svg": 647,
	"./present2Icon.svg": 648,
	"./presentIcon.svg": 649,
	"./promoIcon.svg": 650,
	"./recentIcon.svg": 651,
	"./search2Icon.svg": 652,
	"./search3Icon.svg": 653,
	"./sharpTickIcon copy.svg": 654,
	"./sharpTickIcon.svg": 655,
	"./smallInfoSymbol.svg": 656,
	"./smoothArrowIcon.svg": 657,
	"./successIcon.svg": 658,
	"./supportIcon.svg": 659,
	"./tag1Icon.svg": 660,
	"./tag2Icon.svg": 661,
	"./tag3Icon.svg": 662,
	"./tag4Icon.svg": 663,
	"./tickIcon.svg": 664,
	"./unverified.svg": 665,
	"./verified.svg": 666,
	"./wagerIcon.svg": 667,
	"./wagerTimeIcon.svg": 668,
	"./warningIcon.svg": 669,
	"./zoomIcon.svg": 670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;